import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { EnablePermSessionRecording } from '~/constants/ff.posthog';
import { useFeatureFlag } from './useFeatureFlag';
import { usePosthog } from './usePosthog';

const PERM_JOBS_PATH = '/permanent-jobs';

export const usePermPosthogSessionRecording = () => {
  const location = useLocation();
  const posthog = usePosthog();
  const isRecordingRef = useRef(false);
  const isEnabled = useFeatureFlag(EnablePermSessionRecording);

  useEffect(() => {
    const shouldRecord = isEnabled && location.pathname.startsWith(PERM_JOBS_PATH);

    if (shouldRecord && !isRecordingRef.current) {
      posthog.startSessionRecording();
      isRecordingRef.current = true;
    } else if (!shouldRecord && isRecordingRef.current) {
      posthog.stopSessionRecording();
      isRecordingRef.current = false;
    }
  }, [location.pathname, posthog, isEnabled]);

  // Stop recording on unmount only (separate effect to avoid stop/start flicker on route changes)
  // Ensure recording stops when the app is closed or terminated
  useEffect(() => {
    return () => {
      posthog.stopSessionRecording();
    };
  }, [posthog]);
};
